import './ui/styles/tokens.css';
import './ui/styles/hud.css';
import './ui/styles/screens.css';
import './ui/styles/menu.css';
import './ui/styles/panels.css';
import { App } from './app/App';
import { loadPhotoFacades } from './assets/photoFacades';

const canvas = document.querySelector<HTMLCanvasElement>('#game');
const ui = document.querySelector<HTMLElement>('#ui');
if (!canvas || !ui) throw new Error('index.html is missing #game or #ui');

// Load real photo facades first (if any) so the first street already uses them.
void loadPhotoFacades().then(() => {
  const app = new App(canvas, ui);
  app.start();
  // Dev-only handle for debugging in the browser console. Stripped from production builds.
  if (import.meta.env.DEV) Object.assign(window, { __app: app });
});
